import React from "react";
import { connect } from "react-redux";

import {
  activeFunderContactAffiliationSelector,
  activeFunderContactIdSelector,
  activeFunderContactSelector,
} from "reducers";
import FullPageModal from "components/modals/FullPageModal";
import { FUNDER_CONTACT_MODAL } from "../../../../components/modals";
import FunderContactDetailForm from "../../../funders/FunderContactDetailForm";
import { RecordsTable } from "../../../../components/table";
import FunderContactAffiliationTable from "../../../funders/FunderContactAffiliationTable";

const FunderContactAffiliationModal = ({ funderId = null, funderContactInfo, ...props }) => {
  let title = "Funder Contact Affiliation Detail";
  if (!props.funderContactAffiliation.id) {
    title = "New Funder Contact Affiliation Detail";
  }
  return (
    <FullPageModal modalType={FUNDER_CONTACT_MODAL} title={title}>
      <FunderContactDetailForm funderContactInfo={funderContactInfo} />
      <FunderContactAffiliationTable />
    </FullPageModal>
  );
};

const mapStateToProps = state => {
  return {
    funderContactAffiliation: activeFunderContactAffiliationSelector(state) || {},
    funderContactInfo: activeFunderContactSelector(state),
  };
};

export default connect(mapStateToProps, {})(FunderContactAffiliationModal);
